var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._g({class:{
    'mx-2': _vm.iconName !== 'question',
    'ml-2': _vm.iconName === 'question',
  }},_vm.$listeners),[_c('MIcon',{staticClass:"text-light",style:({ visibility: _vm.iconName === 'question' ? 'hidden' : 'visible' }),attrs:{"name":_vm.iconName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }